import React, { PureComponent } from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import endPoints from '../../../../config/endPoints';
import { AppWrappperHOC } from '../../../Root/HOC';
import Journey from '../../../../containers/NewLanding/Journey';
import { LandingContainer, SubTitle } from '../../../../components';


const StyledAboutUs = styled.section`
  .grayscale-filter{
    filter: grayscale(100%);
  }
  h1{
    font-family: 'Mulish',sans-serif;
    color: ${({ theme }) => theme.LandingBlack};
  }
  p{
    color: ${({ theme }) => theme.LandingBlack};
  }
  .landing{
    padding: 60px 0px;
    position: relative;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      padding: 0px 0px;
      height:auto;
    };
  }
  .vision-mission{
    background-color: ${({ theme }) => theme.webGray};
    .side-heading{
      display: flex;
      align-items: baseline;
    }
  }
  .about-us{
    .gray-box{
      background: ${({ theme }) => theme.tintGray};
      padding: 20px;
      border-radius: 10px;
      height: 150px;
    }
    .white-box{
      background: ${({ theme }) => theme.whiteColor};
      box-shadow: 3px 3px 20px #24415D0F;
      padding: 20px;
      border-radius: 10px;
      height: 150px;
    }
  }
  .about-us-values{
    background-color: ${({ theme }) => theme.webGray};
    .grey-bg{
      background: ${({ theme }) => theme.webGray};
      padding: 40px;
      border-radius: 10px;
      height: 200px;
    }
    .whit-bg{
      background: ${({ theme }) => theme.lightWhite};
      padding: 40px;
      border-radius: 10px;
      height: 200px;
    }
  }
  .company-growth{
    .title{
      font-weight: bold;
      span{
        background: ${({ theme }) => theme.primaryColor};
        padding: 3px 10px;
        color: ${({ theme }) => theme.whiteColor};
        border-radius: 4px;
        font-size: 40px;
      }
    }
  }
`;

class ZaggleOverView extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <StyledAboutUs>
        <div className="gray-greadient">
          <section className="about-us padding-b-6 padding-t-6">
            <LandingContainer>
              <Row align="top" type="flex" justify="start" gutter={32}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <p>
          Incorporated in 2011, we operate in a segment where we interact and interface with our Customers (i.e., businesses)
and end Users (i.e., employees) and are among a small number of uniquely positioned players with a diversified
offering of fintech products and services, having one of the largest number of issued prepaid cards in India in
partnership with certain of our banking partners (which constituted approximately 16.0% of India’s total prepaid
transaction volume, as of March 31, 2023), a diversified portfolio of SaaS, including tax and payroll software, and a
wide touchpoint reach (Source: Frost & Sullivan Report). We are a leading player in spend management, with more
than 50 million prepaid cards issued in partnership with banking partners and more than 2.27 million users served, as
of March 31, 2023. We offer a differentiated value proposition and diversified user base (Source: Frost & Sullivan
Report).
                  </p>
                  <p>
          We are sector-agnostic, and our network of corporate customers (“Customers”) covers the banking and finance,
technology, healthcare, manufacturing, FMCG, infrastructure and automobile industries, among others, where we
have relationships with brands such as TATA Steel, Persistent Systems, Vitech, Inox, Pitney Bowes, Wockhardt,
MAZDA, PCBL (RP – Sanjiv Goenka Group), Hiranandani group, Cotiviti and Greenply Industries.
                  </p>
                  <p>
          We are placed at the intersection of the SaaS and fintech ecosystems, and our SaaS platform is designed for: (i)
business spend management (including expense management and vendor management); (ii) rewards and incentives
management for employees and channel partners; and (iii) gift card management for merchants, which we refer to as
customer engagement management system (“CEMS”). Our core product portfolio include:
                  </p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Col xs={24} sm={24} md={24} lg={12} xl={12} className="nopadding">
                    <div className="gray-box text-center">
                      <img
                        src={endPoints.ZAGGLE_DETAILS_CORPORATE_CILENTS_ICON.URL}
                        alt={endPoints.ZAGGLE_DETAILS_CORPORATE_CILENTS_ICON.ALT}
                      />
                      <SubTitle fontWeight="900" className="nomargin font-24">2,411&#43;</SubTitle>
                      <h3 className="nomargin font-16">Customers</h3>
                    </div>
                    <div className="white-box text-center">
                      <img
                        src={endPoints.ZAGGLE_DETAILS_MILLION_USERS_ICON.URL}
                        alt={endPoints.ZAGGLE_DETAILS_MILLION_USERS_ICON.ALT}
                      />
                      <SubTitle fontWeight="900" className="nomargin font-24">2.2 <span className="font-14">Million&#43;</span></SubTitle>
                      <h3 className="nomargin font-16">Users</h3>
                    </div>
                    <div className="gray-box text-center">
                      <img
                        src={endPoints.ZAGGLE_DETAILS_OFFICES_ICON.URL}
                        alt={endPoints.ZAGGLE_DETAILS_OFFICES_ICON.ALT}
                      />
                      <SubTitle fontWeight="900" className="nomargin font-24">6</SubTitle>
                      <h3 className="nomargin font-16">Offices</h3>
                    </div>
                    <div className="white-box text-center">
                      <img
                        src={endPoints.ZAGGLE_DETAILS_NETWORK_PARTNERS_ICON.URL}
                        alt={endPoints.ZAGGLE_DETAILS_NETWORK_PARTNERS_ICON.ALT}
                      />
                      <SubTitle fontWeight="900" className="nomargin font-24">2</SubTitle>
                      <h3 className="nomargin font-16">Network Partners</h3>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={12} className="nopadding">
                    <div className="white-box text-center">
                      <img
                        src={endPoints.ZAGGLE_DETAILS_MILLION_GIFTCARDS_ICON.URL}
                        alt={endPoints.ZAGGLE_DETAILS_MILLION_GIFTCARDS_ICON.ALT}
                      />
                      <SubTitle fontWeight="900" className="nomargin font-24">50 <span className="font-14">Million</span></SubTitle>
                      <h3 className="nomargin font-16">Prepaid cards since inception</h3>
                    </div>
                    <div className="gray-box text-center">
                      <img
                        src={endPoints.ZAGGLE_DETAILS_EMPLOYEES_ICON.URL}
                        alt={endPoints.ZAGGLE_DETAILS_EMPLOYEES_ICON.ALT}
                      />
                      <SubTitle fontWeight="900" className="nomargin font-24">250&#43;</SubTitle>
                      <h3 className="nomargin font-16">Employees</h3>
                    </div>
                    <div className="white-box text-center">
                      <img
                        src={endPoints.ZAGGLE_DETAILS_BANKING_PARTNERS_ICON.URL}
                        alt={endPoints.ZAGGLE_DETAILS_BANKING_PARTNERS_ICON.ALT}
                      />
                      <SubTitle fontWeight="900" className="nomargin font-24">3</SubTitle>
                      <h3 className="nomargin font-16">Banking Partners</h3>
                    </div>
                  </Col>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <p className="padding-t-3 padding-b-1">
                    <ul className="no-margin">
                      <li className="padding-t-1">
                        <strong>"Propel"</strong>, a corporate SaaS platform for channel rewards and incentives, employee rewards and recognition;
                      </li>
                      <li className="padding-t-1">
                        <strong>"Save"</strong>, a SaaS-based platform and a mobile application to offer expense management solution for business spend management facilitating digitised employee reimbursements and tax benefits;
                      </li>
                      <li className="padding-t-1">
                        <strong>"CEMS"</strong>, a customer engagement management system that enables merchants to comprehensively manage their
customer experiences including rewarding merchants through gift card and loyalty benefits;
                      </li>
                      <li className="padding-t-1">
                        <strong>"Zaggle Payroll Card"</strong>, a prepaid payroll card that allows our Customers to pay contractors, consultants, seasonal
and temporary employees, and unbanked wage workers as an alternative to direct deposits to bank accounts or
cash payments; and
                      </li>
                      <li className="padding-t-1">
                        <strong>"Zoyer"</strong>, an integrated data driven, SaaS based business spend management platform with embedded automated
finance capabilities in core invoice to pay workflows.
                      </li>
                    </ul>
                  </p>
                  <p>
                We offer an ecosystem-based approach across SaaS and fintech, with low customer acquisition and retention costs in
the business-to-business (“B2B”) segment. Our approach revolves around cross-selling, up-selling, and offering our
products and services in partnership with other players in the operating ecosystems. Through our arrangements with
partner banks and fintechs, our Customers are able to offer their employees, channel partners and consumers a suite
of SaaS and fintech solutions. We offer an integrated value proposition through our SaaS platform, providing a
combination of payment instruments as well as an integrated mobile application that digitises business and employee
spends. Application programming interface (“API”) integrations on the platforms provided to our Customers offer
them enhanced convenience and an efficient user experience through a simplified dashboard. This enables a clear,
distinct and integrated access to our products, and gives us an opportunity to promote and offer our third-party
associations through the same dashboard. Our ability to offer diversified SaaS offerings to an existing customer base
enables us to launch new products and cross-sell products to our wide User base. Accordingly, we have partnered
with, and have entered into arrangements with, DBS Bank, Fibe (formerly, EarlySalary) and Tata Securities to offer
their products and value-added services (“VAS”), including insurance, investment and tax planning, to our Users on
our platform.
                  </p>
                </Col>
              </Row>
            </LandingContainer>
          </section>
          <Journey />
        </div>
      </StyledAboutUs>
    );
  }
}

const component = AppWrappperHOC(ZaggleOverView);

export { ZaggleOverView };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/ZaggleOverview/index.jsx